export const FETCH_ITEMMASTER_INIT_ACTION = "FETCH_ITEMMASTER_INIT_ACTION";
export const FETCH_ITEMMASTER_SUCCESS_ACTION =
  FETCH_ITEMMASTER_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMMASTER_FAIL_ACTION =
  FETCH_ITEMMASTER_INIT_ACTION + "_ERROR";

export const FETCH_ITEMMASTER_BRAND_INIT_ACTION =
  "FETCH_ITEMMASTER_BRAND_INIT_ACTION";
export const FETCH_ITEMMASTER_BRAND_SUCCESS_ACTION =
  FETCH_ITEMMASTER_BRAND_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMMASTER_BRAND_FAIL_ACTION =
  FETCH_ITEMMASTER_BRAND_INIT_ACTION + "_ERROR";

export const FETCH_ITEMMASTER_UNIT_INIT_ACTION =
  "FETCH_ITEMMASTER_UNIT_INIT_ACTION";
export const FETCH_ITEMMASTER_UNIT_SUCCESS_ACTION =
  FETCH_ITEMMASTER_UNIT_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMMASTER_UNIT_FAIL_ACTION =
  FETCH_ITEMMASTER_UNIT_INIT_ACTION + "_ERROR";

export const FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION =
  "FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION";
export const FETCH_ITEMMASTER_MEDICALTYPE_SUCCESS_ACTION =
  FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMMASTER_MEDICALTYPE_FAIL_ACTION =
  FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION + "_ERROR";

export const ADD_ITEMMASTER_INIT_ACTION = "ADD_ITEMMASTER_INIT_ACTION";
export const ADD_ITEMMASTER_SUCCESS_ACTION =
  ADD_ITEMMASTER_INIT_ACTION + "_SUCCESS";
export const ADD_ITEMMASTER_FAIL_ACTION = ADD_ITEMMASTER_INIT_ACTION + "_ERROR";

export const DELETE_ITEMMASTER_INIT_ACTION = "DELETE_ITEMMASTER_INIT_ACTION";
export const DELETE_ITEMMASTER_SUCCESS_ACTION =
  DELETE_ITEMMASTER_INIT_ACTION + "_SUCCESS";
export const DELETE_ITEMMASTER_FAIL_ACTION =
  DELETE_ITEMMASTER_INIT_ACTION + "_ERROR";

export const EDIT_ITEMMASTER_INIT_ACTION = "EDIT_ITEMMASTER_INIT_ACTION";
export const EDIT_ITEMMASTER_SUCCESS_ACTION =
  EDIT_ITEMMASTER_INIT_ACTION + "_SUCCESS";
export const EDIT_ITEMMASTER_FAIL_ACTION =
  EDIT_ITEMMASTER_INIT_ACTION + "_ERROR";

export const FETCH_ITEMMASTERINACTIVE_INIT_ACTION =
  "FETCH_ITEMMASTERINACTIVE_INIT_ACTION";
export const FETCH_ITEMMASTERINACTIVE_SUCCESS_ACTION =
  FETCH_ITEMMASTERINACTIVE_INIT_ACTION + "_SUCCESS";
export const FETCH_ITEMMASTERINACTIVE_FAIL_ACTION =
  FETCH_ITEMMASTERINACTIVE_INIT_ACTION + "_ERROR";

export const FETCH_ALLBRANDS_INIT = "FETCH_ALLBRANDS_INIT";
export const FETCH_ALLBRANDS_SUCCESS = FETCH_ALLBRANDS_INIT + "_SUCCESS";
export const FETCH_ALLBRANDS_FAIL = FETCH_ALLBRANDS_INIT + "_FAIL";

export function fetchItemMaster(value) {
  return {
    type: FETCH_ITEMMASTER_INIT_ACTION,
    value: value,
  };
}

export function fetchBrand(value) {
  return {
    type: FETCH_ITEMMASTER_BRAND_INIT_ACTION,
    value: value,
  };
}

export function fetchUnit() {
  return {
    type: FETCH_ITEMMASTER_UNIT_INIT_ACTION,
  };
}

export function fetchMedicalType() {
  return {
    type: FETCH_ITEMMASTER_MEDICALTYPE_INIT_ACTION,
  };
}

export function AddItemMaster(value) {
  return {
    type: ADD_ITEMMASTER_INIT_ACTION,
    value: value,
  };
}
export function ItemMasterSlectedPage(value) {
  return {
    type: FETCH_ITEMMASTER_INIT_ACTION,
    value: value,
  };
}
export function ItemMasterDelete(value) {
  return {
    type: DELETE_ITEMMASTER_INIT_ACTION,
    value: value,
  };
}
export function EditItemmaster(value) {
  return {
    type: EDIT_ITEMMASTER_INIT_ACTION,
    value: value,
  };
}

export function ItemMasterInActive(value) {
  return {
    type: FETCH_ITEMMASTERINACTIVE_INIT_ACTION,
    value: value,
  };
}

export function fetchAllbrands() {
  return {
    type: FETCH_ALLBRANDS_INIT,
  };
}
